import { computed, Signal } from '@angular/core';
import { HttpResourceRef } from '@angular/common/http';

export function resourceValueOr<T>(resource: HttpResourceRef<T>, fallback: T): Signal<T> {
  return computed(() => {
    if (resource.error() || resource.isLoading()) {
      return fallback;
    }

    return resource.value();
  });
}
